// import { useEffect, useState } from "react";
// import ExhibitorCategoryTable from "./ExhibitorCategoryTable";
// import ExhibitorCategoryModal from "./ExhibitorCategoryModal";
// import ExhibitorCategoryForm from "./ExhibitorCategoryForm";
// import Modal from "components/common/Modal";
// import Alert from "components/common/Alert";
// import { useExhibitorCategory } from "./hooks/useExhibitorCategory";
// import { useOrganizers } from "components/company/hooks/useOrganizers";

// export default function ExhibitorCategoryContainer() {
//   const {
//     data,
//     loading,
//     loadCategories,
//     addCategory,
//     editCategory,
//     removeCategory,
//     loadCategoryById,
//     loadCategoryByOrganizer
//   } = useExhibitorCategory();

//   const [editing, setEditing] = useState(null);
//   const [openAdd, setOpenAdd] = useState(false);
//   const [alert, setAlert] = useState({ type: "", message: "" });

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   // const userId = localStorage.getItem("user_id") || "unknown";

//   const userId = "69579c6190a653b640e65639";


//   useEffect(() => {
//     if (selectedOrganizer) {
//       loadCategoryByOrganizer(selectedOrganizer);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };

//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   return (
//     <>
//       <div className="mb-4 flex justify-end">
//         <button
//           className="rounded bg-blue-600 px-4 py-2 text-white"
//           onClick={() => setOpenAdd(true)}
//         >
//           + Add Exhibitor Category
//         </button>
//       </div>

//       {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           autoClose
//           onClose={() => setAlert({ type: "", message: "" })}
//         />
//       )}

//       <ExhibitorCategoryTable
//         data={data}
//         loading={loading}
//         onEdit={async (row) => {
//           const category = await loadCategoryById(row._id);
//           setEditing(category);
//         }}
//         onDelete={async (id) => {
//           if (window.confirm("Are you sure you want to delete this category?")) {
//             try {
//               const res = await removeCategory(id, {
//                 is_deleted: true,
//                 deleted_by: userId,
//               });

//               setAlert({
//                 type: "success",
//                 message: res.message || "Category deleted successfully",
//               });

//               loadCategoryByOrganizer(selectedOrganizer);
//             } catch (error) {
//               setAlert({
//                 type: "error",
//                 message:
//                   error.response?.data?.message ||
//                   "Unable to delete category",
//               });
//             }
//           }
//         }}
//       />

//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <ExhibitorCategoryModal
//           onClose={() => setOpenAdd(false)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("created_by", userId);

//               await addCategory(payload);

//               setOpenAdd(false);
//               loadCategoryByOrganizer(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Something went wrong while creating exhibitor category"
//               );
//             }
//           }}
//         />
//       </Modal>

//       <Modal open={!!editing} onClose={() => setEditing(null)}>
//         <ExhibitorCategoryModal
//           initialData={editing}
//           onClose={() => setEditing(null)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("updated_by", userId);

//               await editCategory(editing._id, payload);

//               setEditing(null);
//               loadCategoryByOrganizer(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Something went wrong while updating exhibitor category"
//               );
//             }
//           }}
//         />
//       </Modal>

//     </>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import { MdSearch, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import ExhibitorCategoryTable from "./ExhibitorCategoryTable";
import ExhibitorCategoryModal from "./ExhibitorCategoryModal";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import { useExhibitorCategory } from "./hooks/useExhibitorCategory";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";

export default function ExhibitorCategoryContainer() {
  const {
    data,
    loading,
    paginationInfo,
    addCategory,
    editCategory,
    removeCategory,
    loadCategoryById,
    loadCategoryByOrganizer,
  } = useExhibitorCategory();

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = "69579c6190a653b640e65639";

  // Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchData = useCallback(() => {
    if (selectedOrganizer) {
      loadCategoryByOrganizer(selectedOrganizer, {
        page,
        limit,
        search: debouncedSearch,
      });
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };

    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const handleDeleteCategory = async (id) => {
    try {
      const res = await removeCategory(id, {
        is_deleted: true,
        deleted_by: userId,
      });

      setAlert({
        type: "success",
        message: res?.message || "Category deleted successfully",
      });

      fetchData();
    } catch (error) {
      setAlert({
        type: "error",
        message:
          error.response?.data?.message || "Unable to delete category",
      });
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search exhibitor category..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Add Exhibitor Category"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => setOpenAdd(true)}
          />
        </div>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          autoClose
          onClose={() => setAlert({ type: "", message: "" })}
        />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading exhibitor categories...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <ExhibitorCategoryTable
            data={data}
            onEdit={async (row) => {
              const category = await loadCategoryById(row._id);
              setEditing(category || row);
            }}
            onDelete={handleDeleteCategory}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalCategories}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      {/* Add Modal */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)} title={"Create Exhibitor Category"}>
        <ExhibitorCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);
              await addCategory(payload);
              setOpenAdd(false);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Something went wrong while creating exhibitor category"
              );
            }
          }}
        />
      </Modal>

      {/* Edit Modal */}
      <Modal open={!!editing} onClose={() => setEditing(null)} title={"Edit Exhibitor Category"}>
        <ExhibitorCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);
              await editCategory(editing._id, payload);
              setEditing(null);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Something went wrong while updating exhibitor category"
              );
            }
          }}
        />
      </Modal>
    </TablePageLayout>
  );
}